/*! responsive.js | Adminuiux 2023-2024 */

"use strict";

document.addEventListener('resize', function () {
    //console.log($(window).width())
})